<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1 class="modalTitle">
      <mat-icon class="iconPosition">file_upload</mat-icon>
      Add Files
    </h1>
  </section>
  <section mat-dialog-content="">
    @if (files.controls.length < 1 || allowMultpleUpload) {
      <div
        (click)="fileInput.click()"
        class="uploadfilecontainer"
        dragDropImages
        >
        <input #fileInput (change)="fileUpload($event)" hidden type="file" multiple />
      </div>
    }
    <section class="files" formArrayName="files">
      @for (image of files.controls; track image) {
        <div class="image">
          @if (image.value.isImage) {
            <img
              [src]="image.value.src"
              alt="Uploaded image."
              />
          }
          @if (!image.value.isImage) {
            <label>{{image.value.name}}</label>
          }
          <button (click)="removeFile(image)" mat-icon-button>
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      }
    </section>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Save product info."
      type="submit"
      >
      <mat-icon>done</mat-icon>
      Done
    </button>
  </section>
</form>
